export default function ArchiveIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 3.16679H0.5M12.5 3.16679V7.16679C12.5 9.68079 12.4993 10.9375 11.7187 11.7188C10.938 12.5001 9.68067 12.5001 7.16667 12.5001H5.83333C3.31933 12.5001 2.06267 12.4995 1.28133 11.7188C0.5 10.9381 0.5 9.68079 0.5 7.16679V3.16679M12.5 3.16679L11.7 2.10012C11.1113 1.31479 10.8167 0.922122 10.3947 0.711455C9.972 0.500122 9.48133 0.500122 8.5 0.500122H4.5C3.51867 0.500122 3.028 0.500122 2.60533 0.711455C2.18333 0.922122 1.88867 1.31479 1.3 2.10012L0.5 3.16679"
        stroke="#674759"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 9.83341V5.50008M4.5 8.16675C4.89333 8.57141 5.94 10.1667 6.5 10.1667C7.06 10.1667 8.10667 8.57141 8.5 8.16675"
        stroke="#674759"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
